"use client";

import { useEffect, useRef, ReactNode } from "react";
import { usePathname } from "next/navigation";

interface ScrollAnimationProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  threshold?: number;
}

export default function ScrollAnimation({
  children,
  className = "",
  delay = 0,
  threshold = 0.1,
}: ScrollAnimationProps) {
  const ref = useRef<HTMLDivElement>(null);

  const pathname = usePathname();


  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    
    element.classList.remove("is-visible");



    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("is-visible");
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, [delay, threshold,  pathname]);

  return (
    <div
      ref={ref}
      className={`scroll-into-view ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}


export { default as ScrollAnimationClient } from "./ScrollAnimationClient";
